
















import Vue from "vue";

export default Vue.extend({
  name: "BreadCrumbItem",
  props: {
    entry: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
  },
});
